<template>
  <div id="Query">
    <Form ref="queryForm" :model="queryForm" :rules="ruleInline">
<!--      <FormItem>-->
<!--        <Select v-model="queryForm.cate" size="large">-->
<!--          <Option value="ranks">等级证书</Option>-->
<!--          <Option value="grades">段位证书</Option>-->
<!--        </Select>-->
<!--      </FormItem>-->
      <FormItem prop="mem_name">
        <Input v-model="queryForm.mem_name" size="large">
          <span slot="prepend">会员姓名</span>
        </Input>
      </FormItem>
      <FormItem prop="cer_no">
        <Input v-model="queryForm.cer_no" size="large">
          <span slot="prepend">证书编号</span>
        </Input>
      </FormItem>
      <FormItem style="text-align: center;" v-if="showQueryButton">
        <i-button size="large" style="width: 100%;" type="primary" @click="clickQueryButtonAction">
          {{this.cate === 'ranks' ? '查询等级证书' : '查询段位证书'}}
        </i-button>
      </FormItem>
    </Form>

    <Modal
        width="700"
        v-model="showQueryInfo"
        :title="modalTitle"
        :footer-hide="true"
    >
      <div class="certificate-info">
        <div class="certificate-container">
          <div class="level">
            <div>
              {{queryInfo['cer_cn']}}
            </div>
            <div>
              {{queryInfo['cer_en']}}
            </div>
          </div>


          <div class="stu-info">
            <div class="item-info">
              {{queryInfo['cer_no']}}
            </div>
            <div class="item-info">
              {{queryInfo['m_name']}}
            </div>
            <div class="item-info">
              {{queryInfo['birth']}}
            </div>
          </div>

          <div class="tissue-info">
            <div class="item-info">
              {{queryInfo['lea_leader']}}
            </div>
            <div class="item-info">
              {{queryInfo['time']}}
            </div>
          </div>
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
import {queryCertificate} from "@/request/web/query";

export default {
  name: "Query",
  props: {
    showQueryButton: true,
    cate: 'ranks'
  },
  // 页面数据
  data() {
    return {
      showQueryInfo: false,
      queryInfo: {},
      modalTitle: '查询到的证书信息',
      buttonText: '查询等级证书',
      queryForm : {
        cate    : 'ranks',  // 证书类型
        mem_name: '',       // 会员名称
        cer_no  : ''        // 证书编号
      },
      ruleInline: {
        cate: [
          { required: true, message: '请选择证书类型' }
        ],
        mem_name: [
          { required: true, message: '请输入会员姓名', trigger: 'blur' }
        ],
        cer_no: [
          { required: true, message: '请输入证书编号', trigger: 'blur' },
          { type: 'string', min: 6, message: '输入的证书编号错误', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    clickQueryButtonAction() {
      this.showQueryInfo = false;
      this.queryForm.cate = this.cate
      this.$refs['queryForm'].validate((valid) => {
        if (valid) {
          queryCertificate({ queryInfo: this.queryForm }).then(res=> {
            let { error, data, message } = res.data;
            if (error === 200) {
              this.showQueryInfo = true;
              this.modalTitle = this.queryForm['cate'] === 'ranks' ? '查询到的等级证书信息' : '查询到的段位证书信息'
              this.queryInfo = data;
            } else {
              this.$Notice.error({
                title : '错误提示',
                desc  : message
              })
            }
          })
        }
      })
    }
  }
}
</script>

<style scoped>
.certificate-info {
  width: 740px;
  height: 970px;
  background-image: url("../assets/img/certificate_rank.jpg");
  background-repeat: no-repeat;
  background-size: contain;
}

.certificate-info .certificate-container {
  height: 100%;
  width: 100%;
  position: absolute
}

.certificate-info .certificate-container .level {
  margin-top: 290px;
  width: 670px;
  height: 80px;
  /*background-color: rgba(100, 100, 100, 0.5);*/
  font-size: 25px;
  font-weight: bolder;
  color: #313540;
  text-align: center;
}

.certificate-info .certificate-container .stu-info {
  margin-top: 50px;
  width: 670px;
  height: 120px;
  /*background-color: rgba(100, 100, 100, 0.5);*/
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  font-weight: bold;
  color: #313540;
}

.certificate-info .certificate-container .stu-info .item-info {
  width: 220px;
  height: 40px;
  padding-left: 100px;
}

.certificate-info .certificate-container .tissue-info {
  margin-top: 130px;
  width: 670px;
  height: 90px;
  /*background-color: rgba(100, 100, 100, 0.5);*/
}

.certificate-info .certificate-container .tissue-info .item-info{
  width: 200px;
  margin-left: 190px;
  height:45px;
  line-height: 45px;
  font-size: 16px;
  font-weight: bold;
  color: #313540;
}
</style>
